/*eslint-disable */
var $ = window.jQuery = require('jquery');
import {
  bus
} from '@/main';
export default {
  name: 'paper-note-read-view',
  components: {
  },
  props: ['notesViewDATA'],
  data () {
    return {
      notesViewData:null,
      notesViewDataResults:[],
      fullViewModeEditable:true,
      noteViewInfo:null
    }
  },
  computed: {

  },
  mounted () {
    this.notesViewData = this.notesViewDATA
    this.notesViewDataResults = this.notesViewData.notes
  },
  methods: {
    noteViewInfoMethod(data){
      this.noteViewInfo = data
      this.fullViewModeEditable = false
    },
    backToFirstView(){
      this.fullViewModeEditable = true
    },
    backToNormalViewMethod(){
      $('body').removeClass('body_right_scroll_remove')
      bus.$emit('notesViewPopupStateBus', false);
    },
  }
}